/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SubCategory = {
    properties: {
        nameInternal: {
            type: 'string',
            isRequired: true,
        },
        leagueCategory: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        isCup: {
            type: 'boolean',
            isRequired: true,
        },
        isMain: {
            type: 'boolean',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
